// O nome cru da tool no runner vira rótulo legível na tela Testar (Fase 7): tira o prefixo do runtime
// (`captain--tools--`), marca as pontes do Kernel (`polaris_`/`polaris--` → "polaris: ") e o sufixo `_tool`.
export const prettyToolName = name =>
  String(name)
    .replace(/^captain--tools--/, '')
    .replace(/^polaris(--|_)/, 'polaris: ')
    .replace(/_tool$/, '')
    .replaceAll('_', ' ');
